import courseService from 'ApiService/Admin/courseService';
import studentService from 'ApiService/Admin/studentService';
import Card from 'components/card';
import { AuthContext } from 'contexts/AuthContext';
import ConfirmationModal from 'pages/Common/ConfirmationModal';
import { useContext, useEffect, useState, useCallback } from 'react';
import toast from 'react-hot-toast';
import StepperControl from 'views/admin/main/users/newUser/components/Admissions/StepperControl';
import Stepper from 'views/admin/main/users/newUser/components/Stepper';
import { UseContextProvider } from 'views/admin/main/users/newUser/contexts/StepperContext';
import AcademicRecords from './Steps/AcademicRecords';
import EnrollmentInfo from './Steps/EnrollmentInfo';
import WorkExperience from './Steps/WorkExperience';
import batchStructureService from 'ApiService/Admin/batchService';

const AddStudent = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const { state } = useContext(AuthContext);
  const selectedBranch = state?.selectedBranch || '';
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [studentData, setStudentData] = useState({
    profilePicture: null,
    name: '',
    email: '',
    contactNumber: '',
    dateOfBirth: '',
    gender: '',
    parentName: '',
    ParentContactNo: '',
    address: {
      street: '',
      city: '',
      state: '',
      postalCode: '',
      country: '',
    },

    enrollments: [
      {
        course: '',
        batchStructure: '',
        batch: '',
        enrollmentDate: '',
        notes: '',
      },
    ],

    // enrollments: [],
    academicRecords: [],
    workExperience: [],
    fees: {
      totalAmount: null,
      isFullPayment: true,
      installments: [],
    },
    jobLocationPreference: [],
    preferredSalary: 'Any Salary',
    termsAndConditionType: 'Job Guarantee Training',
    staffNotes: '',
    selectedBranch: selectedBranch,
  });
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [disable, setDisable] = useState(true);
  const [loadingCourses, setLoadingCourses] = useState(true);
  const [batchStructures, setBatchStructures] = useState([]);
  const [batches, setBatches] = useState([]);
  const [loadingBatchStructures, setLoadingBatchStructures] = useState(false);
  const [loadingBatches, setLoadingBatches] = useState(false);

  const fetchCourses = useCallback(async () => {
    setLoadingCourses(true);
    try {
      const response = await courseService.getAllCourses(selectedBranch);
      if (response.data.success) {
        setCourses(response.data.courses);
      } else {
        toast.error('Failed to fetch courses.');
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Failed to fetch courses.');
    } finally {
      setLoadingCourses(false);
    }
  }, [selectedBranch]);

  useEffect(() => {
    fetchCourses();
  }, [fetchCourses]);
  const capitalizeWords = (str) => {
    return str.replace(/\b\w/g, (char) => char.toUpperCase());
  };

  //add and handle

  const handleInputChange = (event) => {
    const { id, value, files } = event.target;
    const formattedValue = id === 'name' ? capitalizeWords(value) : value;
    if (id === 'profilePicture' && files && files[0]) {
      setStudentData((prev) => ({
        ...prev,
        profilePicture: files[0],
      }));
      return;
    }
    if (id.startsWith('address.')) {
      const field = id.split('.')[1];
      setStudentData((prevData) => ({
        ...prevData,
        address: {
          ...prevData.address,
          [field]: formattedValue,
        },
      }));
    } else {
      setStudentData((prevData) => ({
        ...prevData,
        [id]: formattedValue,
      }));
    }
  };
  // const handleEnrollmentChange = (index, field, value) => {
  //   const newEnrollments = [...studentData.enrollments];
  //   newEnrollments[index] = {
  //     ...newEnrollments[index],
  //     [field]: value,
  //   };

  //   setStudentData((prevData) => ({
  //     ...prevData,
  //     enrollments: newEnrollments,
  //   }));
  // };

  const handleEnrollmentChange = async (index, field, value) => {
    const newEnrollments = [...studentData.enrollments];

    // COURSE CHANGE → reset structure & batch
    if (field === 'course') {
      newEnrollments[index] = {
        ...newEnrollments[index],
        course: value,
        batchStructure: '',
        batch: '',
      };

      setBatchStructures([]);
      setBatches([]);

      if (value) {
        setLoadingBatchStructures(true);

        try {
          const res = await batchStructureService.getBatchStructuresByCourse(
            value
          );
          if (res.data.success) {
            setBatchStructures(res.data.batchStructures || []);
          }
        } catch {
          toast.error('Failed to load batch structures');
        } finally {
          setLoadingBatchStructures(false);
        }
      }
    }

    // BATCH STRUCTURE CHANGE → reset batch
    else if (field === 'batchStructure') {
      newEnrollments[index] = {
        ...newEnrollments[index],
        batchStructure: value,
        batch: '',
      };

      setBatches([]);

      // 🔒 IMPORTANT GUARD
      if (!value) {
        setStudentData((prev) => ({
          ...prev,
          enrollments: newEnrollments,
        }));
        return;
      }

      try {
        setLoadingBatches(true);
        const res = await courseService.getBatchesByCourseStructure(
          newEnrollments[index].course,
          value,
          selectedBranch
        );

        if (res.data.success) {
          setBatches(res.data.batches || []);
        }
      } catch (err) {
        toast.error(err?.response?.data?.message || 'Failed to load batches');
      } finally {
        setLoadingBatches(false);
      }
    }

    // NORMAL FIELD
    else {
      newEnrollments[index] = {
        ...newEnrollments[index],
        [field]: value,
      };
    }

    setStudentData((prevData) => ({
      ...prevData,
      enrollments: newEnrollments,
    }));
  };

  const addEnrollment = () => {
    setStudentData((prevData) => ({
      ...prevData,
      enrollments: [
        ...prevData.enrollments,
        {
          course: '',
          batchStructure: '',
          batch: '',
          enrollmentDate: '',
          status: 'Active',
          notes: '',
        },
      ],
    }));
  };

  const handleFeesChange = (field, value) => {
    setStudentData((prevData) => ({
      ...prevData,
      fees: {
        ...prevData.fees,
        [field]: value,
      },
    }));
  };

  const addInstallment = () => {
    setStudentData((prevData) => ({
      ...prevData,
      fees: {
        ...prevData.fees,
        installments: [
          ...prevData.fees.installments,
          {
            amount: '',
            dueDate: '',
            isPaid: false,
          },
        ],
      },
    }));
  };

  const handleInstallmentChange = (index, field, value) => {
    setStudentData((prevData) => {
      const newInstallments = [...prevData.fees.installments];
      newInstallments[index] = {
        ...newInstallments[index],
        [field]: field === 'amount' ? Number(value) : value,
      };
      return {
        ...prevData,
        fees: {
          ...prevData.fees,
          installments: newInstallments,
        },
      };
    });
  };

  const handleAcademicRecordChange = (index, event) => {
    const { id, value } = event.target;
    console.log(index, id, value, 'handleAcademicRecordChange');
    const [field] = id.split('-');

    if (field === 'yearOfCompletion' && isNaN(value)) return;

    const newAcademicRecords = [...studentData.academicRecords];
    newAcademicRecords[index] = {
      ...newAcademicRecords[index],
      [field]: value,
    };

    setStudentData((prevData) => ({
      ...prevData,
      academicRecords: newAcademicRecords,
    }));
  };

  const addAcademicRecord = () => {
    setStudentData((prevData) => ({
      ...prevData,
      academicRecords: [
        ...prevData.academicRecords,
        {
          stream: '',
          level: '',
          institutionName: '',
          board: '',
          yearOfCompletion: '',
          percentage: '',
          gpa: '',
        },
      ],
    }));
  };

  const handleWorkExperienceChange = (index, event) => {
    const { id, value } = event.target;
    const newWorkExperience = [...studentData.workExperience];
    const [field] = id.split('-');

    newWorkExperience[index] = {
      ...newWorkExperience[index],
      [field]: value,
    };

    setStudentData((prevData) => ({
      ...prevData,
      workExperience: newWorkExperience,
    }));
  };

  const addWorkExperience = () => {
    setStudentData((prevData) => ({
      ...prevData,
      workExperience: [
        ...prevData.workExperience,
        {
          companyName: '',
          position: '',
          startDate: '',
          endDate: '',
          responsibilities: '',
          skills: [],
        },
      ],
    }));
  };

  //submit
  useEffect(() => {
    setStudentData((prev) => ({
      ...prev,
      selectedBranch: selectedBranch,
    }));
  }, [selectedBranch]);

  const confirmCreation = () => {
    setIsModalOpen(true);
  };

  const handleSubmit = async () => {
    console.log('clicked submit !!!!!!!!!!');

    if (isSubmitting) return;

    setIsSubmitting(true);
    setLoading(true);

    try {
      // Validate required fields
      if (studentData.profilePicture === null) {
        toast.error('Profile Pic is required');
        setLoading(false);
        return;
      }
      if (!studentData.name) {
        toast.error('Name is required');
        setLoading(false);
        return;
      }
      if (!studentData.email) {
        toast.error('Email is required');
        setLoading(false);
        return;
      }
      if (!studentData.contactNumber) {
        toast.error('Contact number is required');
        setLoading(false);
        return;
      }
      if (!studentData.dateOfBirth) {
        toast.error('Date of birth is required');
        setLoading(false);
        return;
      }
      if (!studentData.gender) {
        toast.error('Gender is required');
        setLoading(false);
        return;
      }
      if (
        !studentData.address.street ||
        !studentData.address.city ||
        !studentData.address.state ||
        !studentData.address.postalCode ||
        !studentData.address.country
      ) {
        toast.error('All address fields are required');
        setLoading(false);
        return;
      }
      if (!studentData.fees.totalAmount) {
        toast.error('Total amount is required');
        setLoading(false);
        return;
      }

      if (studentData.enrollments.length === 0) {
        toast.error('At least one enrollment is required');
        setLoading(false);
        return;
      }
      if (studentData.academicRecords.length === 0) {
        toast.error('At least one academic record is required');
        setLoading(false);
        return;
      }
      if (studentData.jobLocationPreference.length === 0) {
        toast.error('At least one job preference is required');
        setLoading(false);
        return;
      }

      if (
        studentData.fees.installments.length === 0 &&
        !studentData.fees.isFullPayment
      ) {
        toast.error('Installments are required if not paying in full');
        setLoading(false);
        return;
      }

      // Create FormData object
      const formData = new FormData();

      if (studentData.profilePicture) {
        formData.append('file', studentData.profilePicture);
      }

      const studentDataWithoutFile = { ...studentData };
      delete studentDataWithoutFile.profilePicture;

      formData.append('studentData', JSON.stringify(studentDataWithoutFile));

      const response = await studentService.createStudent(formData);

      if (response.data.success) {
        toast.success(response.data.message);
        resetStudentData();
        fetchCourses();
        setCurrentStep(1);
        setIsModalOpen(false);
      } else {
        toast.error(response.data.message || 'Failed to create student.');
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Failed to submit form.');
    } finally {
      setLoading(false);
      setIsSubmitting(false);
    }
  };

  const resetStudentData = () => {
    setStudentData({
      profilePicture: null,
      name: '',
      email: '',
      contactNumber: '',
      dateOfBirth: '',
      gender: '',
      parentName: '',
      ParentContactNo: '',
      address: {
        street: '',
        city: '',
        state: '',
        postalCode: '',
        country: '',
      },
      enrollments: [
        {
          course: '',
          batchStructure: '',
          batch: '',
          enrollmentDate: '',
          notes: '',
        },
      ],
      academicRecords: [],
      workExperience: [],
      fees: {
        totalAmount: null,
        isFullPayment: true,
        installments: [],
      },
      jobLocationPreference: [],
      preferredSalary: 'Any Salary',
      staffNotes: '',
    });
  };

  const steps = [
    { stepNo: 1, name: 'Personal Details' },
    { stepNo: 2, name: 'Academic and Employment Details' },
    { stepNo: 3, name: 'Enrollment and Fees' },
  ];
  //remove
  const removeEnrollment = (index) => {
    setStudentData((prevData) => {
      const updatedEnrollments = prevData.enrollments.filter(
        (_, i) => i !== index
      );
      return { ...prevData, enrollments: updatedEnrollments };
    });
  };

  const removeInstallment = (index) => {
    setStudentData((prevData) => {
      const updatedInstallments = prevData.fees.installments.filter(
        (_, i) => i !== index
      );
      return {
        ...prevData,
        fees: { ...prevData.fees, installments: updatedInstallments },
      };
    });
  };

  const removeAcademicRecord = (index) => {
    setStudentData((prevData) => {
      const updatedRecords = prevData.academicRecords.filter(
        (_, i) => i !== index
      );
      return { ...prevData, academicRecords: updatedRecords };
    });
  };

  const removeWorkExperience = (index) => {
    setStudentData((prevData) => {
      const updatedExperiences = prevData.workExperience.filter(
        (_, i) => i !== index
      );
      return { ...prevData, workExperience: updatedExperiences };
    });
  };

  const displayStep = (step) => {
    switch (step.stepNo) {
      case 1:
        return (
          <AcademicRecords
            studentData={studentData}
            handleInputChange={handleInputChange}
            setDisable={setDisable}
          />
        );
      case 2:
        return (
          <WorkExperience
            studentData={studentData}
            addAcademicRecord={addAcademicRecord}
            handleAcademicRecordChange={handleAcademicRecordChange}
            handleWorkExperienceChange={handleWorkExperienceChange}
            addWorkExperience={addWorkExperience}
            handleInputChange={handleInputChange}
            removeAcademicRecord={removeAcademicRecord}
            removeWorkExperience={removeWorkExperience}
            setDisable={setDisable}
            setStudentData={setStudentData}
          />
        );
      case 3:
        return (
          // <EnrollmentInfo
          //   handleInputChange={handleInputChange}
          //   studentData={studentData}
          //   handleEnrollmentChange={handleEnrollmentChange}
          //   courses={courses}
          //   addEnrollment={addEnrollment}
          //   addInstallment={addInstallment}
          //   handleFeesChange={handleFeesChange}
          //   handleInstallmentChange={handleInstallmentChange}
          //   removeEnrollment={removeEnrollment}
          //   removeInstallment={removeInstallment}
          //   setDisable={setDisable}
          //   loadingCourses={loadingCourses}
          // />
          <EnrollmentInfo
            studentData={studentData}
            handleEnrollmentChange={handleEnrollmentChange}
            courses={courses}
            batchStructures={batchStructures}
            batches={batches}
            loadingBatchStructures={loadingBatchStructures}
            loadingBatches={loadingBatches}
            addEnrollment={addEnrollment}
            addInstallment={addInstallment}
            handleFeesChange={handleFeesChange}
            handleInstallmentChange={handleInstallmentChange}
            removeEnrollment={removeEnrollment}
            removeInstallment={removeInstallment}
            setDisable={setDisable}
            loadingCourses={loadingCourses}
            handleInputChange={handleInputChange}
          />
        );
      default:
    }
  };

  const handleClick = (direction) => {
    let newStep = currentStep;

    direction === 'next' ? newStep++ : newStep--;
    // check if steps are within bounds
    newStep > 0 && newStep <= steps.length && setCurrentStep(newStep);
  };

  // useFormKeyboardSubmit(handleSubmit, disable, loading);

  const getConfirmationMessage = () => {
    return `


      Student: ${studentData.name}
      Email: ${studentData.email}
      Contact: ${studentData.contactNumber}
      DOB: ${studentData?.dateOfBirth}
      Gender: ${studentData.gender}
      Address: ${studentData.address.city}, ${studentData.address.state}
      Payment: ${studentData.fees.isFullPayment ? 'Full Payment' : 'Installments'
      } - ${studentData.fees.totalAmount}
      Enrollments: ${studentData.enrollments.length} course(s)
    `;
  };

  return (
    <div className="md-mt-[3] mt-3 h-full w-full">
      <div className="h-[350px] w-full rounded-[20px] bg-gradient-to-br from-brand-400 to-brand-600 md:h-[390px]" />
      <div className="w-md:2/3 mx-auto h-full w-5/6 md:px-3  3xl:w-7/12">
        <div className="-mt-[280px] w-full pb-10 md:-mt-[340px] md:px-[70px]">
          <Stepper steps={steps} currentStep={currentStep} />
        </div>
        <Card extra={'h-full mx-auto pb-3'}>
          <div className="rounded-[20px]">
            <UseContextProvider>
              {displayStep(steps[currentStep - 1])}
            </UseContextProvider>
          </div>
          {/* navigation button */}
          <StepperControl
            handleClick={handleClick}
            currentStep={currentStep}
            steps={steps}
            loading={loading}
            disable={disable}
            handleSubmit={confirmCreation}
          />
        </Card>
      </div>
      <ConfirmationModal
        isOpen={isModalOpen}
        onClose={() => {
          if (!isSubmitting) {
            setIsModalOpen(false);
          }
        }}
        onConfirm={handleSubmit}
        title="Are you sure you want to register this student?"
        message={getConfirmationMessage()}
        confirmText={isSubmitting ? 'Creating...' : 'Yes, Create'}
        cancelText="Cancel"
        icon="info"
        disableConfirm={isSubmitting}
      />
    </div>
  );
};

export default AddStudent;
